"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _Input = _interopRequireDefault(require("../Input"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * This component makes it easier to use Vanilla form inputs with Formik. It
 * makes use of Formik's context to automatically map errors, values, states
 * etc. onto the provided field.
 */
const FormikField = _ref => {
  let {
    component: Component = _Input.default,
    displayError = true,
    name,
    value,
    label,
    ...props
  } = _ref;
  const [field, meta] = (0, _formik.useField)({
    name,
    type: props.type,
    value
  });
  return /*#__PURE__*/_react.default.createElement(Component, _extends({
    "aria-label": label,
    error: meta.touched && displayError ? meta.error : null,
    label: label
  }, field, props));
};
var _default = exports.default = FormikField;